import React, { ReactNode } from 'react';

import { DashboardTileIcon } from 'components/FinancialCheckup/FinancialDashboard/DashboardActionTiles/DashboardTileCard';
import { DashboardTileIconTone } from 'components/FinancialCheckup/FinancialDashboard/DashboardActionTiles/types';

import styles from './DashboardSheetHeader.module.scss';

interface DashboardSheetHeaderProps {
  title: string;
  icon: ReactNode;
  iconTone: DashboardTileIconTone;
}

const DashboardSheetHeader: React.FC<DashboardSheetHeaderProps> = ({ title, icon, iconTone }) => (
  <div className={styles.sheetHeader}>
    <DashboardTileIcon tone={iconTone}>{icon}</DashboardTileIcon>
    <h3 className={styles.title}>{title}</h3>
  </div>
);

export default DashboardSheetHeader;
